import { tokenAxios } from "@/utils/axios";
import { useAppState } from "@/contexts/app-state";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildApiUrl } from "@/utils/api";

interface UpdateTaoArgs {
    taoId: number;
    practiceId: string;
    requestedUser: string;
    taoStatus: boolean;
}

const postUpdateTaoStatus = async (params: UpdateTaoArgs) => {
    await tokenAxios().post(buildApiUrl("updateTaoStatus"), { ...params });
};

export const useUpdateTaoStatus = () => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutate } = useMutation({
        mutationFn: postUpdateTaoStatus,
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["tao-routing-rules"],
          });
        },
      });

    const updateTaoStatus = (taoId: number, taoStatus: boolean) =>
        mutate({
            taoId: taoId,
            taoStatus: taoStatus,
            practiceId: practiceId,
            requestedUser: loggedInUser,
        }
    );

        return {
            isPending,
            isError,
            isSuccess,
            updateTaoStatus,
          };
};
